const getPaymentSource = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const medicareInsurance = patient['Insurance Information'].find(item => item['Claim Filling Code'].ID === 5);
  if (medicareInsurance) {
    return '31';
  }
  return '11';
};

export default getPaymentSource;



// WEBPACK FOOTER //
// ./src/utils/print/getPaymentSource.js